import * as React from 'react';
import '../../common/styles.less';
import { ChangeEvent } from 'react';

// [ComponentUsage]
// <InputField
// 	name="name"
// 	placeholder="Name"
// 	inputFieldLabel="Name"
// 	isDisabled={true}
// 	value={this.state.name}
// 	onChange={this.handleChange}
// 	hasError={false}
// 	errorMessage="WARNING"
// 	customField="months"
// />

export interface InputFieldProps {
	inputType: 'text' | 'password' | 'textarea' | 'number';
	name?: string;
	inputFieldLabel?: string;
	value?: string;
	defaultValue?: string;
	placeholder?: string;
	isRequired?: boolean;
	isDisabled?: boolean;
	hasError?: boolean;
	errorMessage?: string;
	onChange?: (event: ChangeEvent<any>) => void;
	customField?: string;
	textAreaHeight?: string;
	minPossibleValue?: number;
	maxLength?: number;
}

export const InputField: React.FC<InputFieldProps> = (props: InputFieldProps): JSX.Element => {
	const {
		/** Type of input */
		inputType,
		/** Name of the input field */
		name,
		/** Text shown in the input label */
		inputFieldLabel,
		/** Value of the input */
		value,
		/** DefaultValue of the input */
		defaultValue,
		/** Placeholder shown in the input field */
		placeholder,
		/** Boolean for controlling if is required or not */
		isRequired = false,
		/** Boolean for controlling if exist or not an error */
		hasError = false,
		/** Error message shown in case it exists any */
		errorMessage = '',
		/** Boolean for controlling if the input is disabled or not */
		isDisabled = false,
		/** Function onChange to manipulate the value */
		onChange = undefined,
		/** Custom field  */
		customField = '',
		/** Height  of the textarea */
		textAreaHeight = '100',
		minPossibleValue,
		maxLength,
	} = props;

	return (
		<div className={`ds-input-field-${customField === '' ? 'simple' : 'content'} flex-inline`}>
			<label className={`${isRequired ? 'required' : ''}`} htmlFor={name}>
				{inputFieldLabel}
			</label>
			<div className="ds-input-textbox">
				{inputType === 'textarea' ? (
					<textarea
						id={name}
						name={name}
						placeholder={placeholder}
						defaultValue={defaultValue}
						value={value}
						onChange={onChange}
						disabled={isDisabled}
						className="text-align-left"
						style={{ height: textAreaHeight + 'px', resize: 'none' }}
					/>
				) : (
					<input
						id={name}
						type={inputType}
						name={name}
						placeholder={placeholder}
						defaultValue={defaultValue}
						value={value}
						min={minPossibleValue}
						onChange={onChange}
						disabled={isDisabled}
						className="text-align-left"
						maxLength={maxLength ? maxLength : undefined}
					/>
				)}
				<div className={`ds-input-right-section ${isDisabled ? 'input-disabled' : ''}`}>
					<span className="ds-right-content">{customField}</span>
				</div>
			</div>
			<div className="input-error-text">
				<span>{`${hasError ? errorMessage : ''}`}</span>
			</div>
		</div>
	);
};
